import React, { useEffect, useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormHelperText, Stack, TextField, Typography, Checkbox, FormControlLabel, Grid, Select, MenuItem, Divider } from '@mui/material'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RichTextComponent from '../../../CommonComponents/RichTextComponent';
import { createLicense, getCurrencyList, getIntegrationList, getLicenseById, updateLicense } from '../../../api/license';
import { useNavigate, useParams } from 'react-router-dom';
import { showErrorToast, showSuccessToast } from '../../../toastUtils';
import Loader from '../../../CommonComponents/Loader';
import { createSubscription } from '../../../api/organization';
import CustomBreadcrumb from '../../../CommonComponents/CommonBreadcrumb';
const fieldWrapperStyles = {
    bgcolor: '#fff',
    py: 1,
    px: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    border: '1px solid #ccc',
    borderRadius: '7px',
};

// const removeEdgeQuotes = (str) => {
//     return str.replace(/^['"]|['"]$/g, '');
// };
const removeEdgeQuotes = (str) => {
    try {
        const parsed = typeof str === "string" && str.startsWith('"') ? JSON.parse(str) : str;
        return parsed.replace(/^['"]|['"]$/g, '');
    } catch {
        return str.replace(/^['"]|['"]$/g, '');
    }
};

export default function CreateOrViewLicense({ section, onClose, onCloseSubscription }) {
    const [formData, setFormData] = useState({
        planName: '',
        startDate: null,
        expiryDate: null,
        currency: '62',
        price: '',
        validity: '',
        description: '',

        dataRequestLimit: '',
        dataRequestSoftLimit: true,
        dataRequestOverageType: 'absolute', // <-- added
        dataRequestOverageNumber: '',        // <-- added

        pageViewsLimit: '',
        pageViewsSoftLimit: true,
        pageViewsOverageType: 'absolute',    // <-- added
        pageViewsOverageNumber: '',          // <-- added

        usersLimit: '',
        usersSoftLimit: false,
        usersOverageType: 'absolute',         // <-- added
        usersOverageNumber: '',               // <-- added

        domainsLimit: '',
        domainsSoftLimit: false,
        domainsOverageType: 'absolute',       // <-- added
        domainsOverageNumber: '',             // <-- added

        dataBreach: false,
        geoLocation: false,
        privacyPolicy: false,

        inclusion: '',
        exclusion: ''
    });


    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const { id } = useParams();
    const [loading, setLoading] = useState(section ? false : id ? true : false);
    const [currencyList, setCurrencyList] = useState([]);
    const [integrationList, setIntegrationList] = useState([])
    const [isEdited, setIsEdited] = useState(false)
    const navigate = useNavigate()


    useEffect(() => {
        const fetchCurrencyList = async () => {
            try {
                const response = await getCurrencyList();
                if (response.success) {
                    setCurrencyList(response.data);
                } else {
                    console.error("Failed to fetch currency list:", response.message);
                }
            } catch (error) {
                console.error("Error fetching currency list:", error);
            }
        };

        fetchCurrencyList();
    }, []);

    useEffect(() => {
        const fetchIntegrationList = async () => {
            try {
                const response = await getIntegrationList();
                if (response.success) {
                    setIntegrationList(response.data);
                } else {
                    console.error("Failed to fetch currency list:", response.message);
                }
            } catch (error) {
                console.error("Error fetching currency list:", error);
            }
        };

        fetchIntegrationList();
    }, []);

    useEffect(() => {
        const fetchLicense = async () => {
            if (id && integrationList?.length > 0 && currencyList?.length > 0 && !section) {
                try {
                    setLoading(true);
                    const response = await getLicenseById(id);
                    if (response.success) {
                        const licenseData = response.data;

                        let integrationData = {};
                        integrationList.forEach(ele => {
                            integrationData[ele.name] = licenseData.plan_attributes.integrations.includes(ele.name);
                        });

                        setFormData({
                            planName: licenseData.plan_base_details.plan_name || '',
                            startDate: licenseData.plan_base_details.start_date || null,
                            expiryDate: licenseData.plan_base_details.end_date || null,
                            currency: licenseData.plan_base_details.currency || '',
                            price: licenseData.plan_base_details.price || '',
                            validity: licenseData.plan_base_details.validity || '',
                            description: licenseData.plan_base_details.plan_description || '',

                            dataRequestLimit: licenseData.plan_attributes.data_requests.limit || '',
                            pageViewsLimit: licenseData.plan_attributes.page_views.limit || '',
                            usersLimit: licenseData.plan_attributes.users.limit || '',
                            domainsLimit: licenseData.plan_attributes.domains.limit || '',

                            dataRequestSoftLimit: licenseData.plan_attributes.data_requests.is_soft_limit || false,
                            pageViewsSoftLimit: licenseData.plan_attributes.page_views.is_soft_limit || false,
                            usersSoftLimit: licenseData.plan_attributes.users.is_soft_limit || false,
                            domainsSoftLimit: licenseData.plan_attributes.domains.is_soft_limit || false,

                            dataRequestOverageType: licenseData.plan_attributes.data_requests.overage_type || 'absolute',
                            dataRequestOverageNumber: licenseData.plan_attributes.data_requests.overage || '',
                            pageViewsOverageType: licenseData.plan_attributes.page_views.overage_type || 'absolute',
                            pageViewsOverageNumber: licenseData.plan_attributes.page_views.overage || '',
                            usersOverageType: licenseData.plan_attributes.users.overage_type || 'absolute',
                            usersOverageNumber: licenseData.plan_attributes.users.overage || '',
                            domainsOverageType: licenseData.plan_attributes.domains.overage_type || 'absolute',
                            domainsOverageNumber: licenseData.plan_attributes.domains.overage || '',

                            dataBreach: licenseData.plan_attributes.data_breach || false,
                            geoLocation: licenseData.plan_attributes.geo_location || false,
                            privacyPolicy: licenseData.plan_attributes.privacy_policy_generator || false,

                            inclusion: removeEdgeQuotes(licenseData.plan_inclusions) || '',
                            exclusion: removeEdgeQuotes(licenseData.plan_exclusions) || '',

                            ...integrationData
                        });

                    }
                } catch (error) {
                    console.error("Failed to fetch license:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchLicense();
    }, [id, integrationList, currencyList, section]);

    const validate = () => {
        const newErrors = {};

        // Plan name
        if (!formData.planName.trim()) {
            newErrors.planName = 'Plan name is required';
        } else if (formData.planName.length < 3) {
            newErrors.planName = 'Plan name must be at least 3 characters';
        }

        // Dates
        if (!formData.startDate) {
            newErrors.startDate = 'Start date is required';
        }

        // if (!formData.expiryDate) {
        //     newErrors.expiryDate = 'Expiry date is required';
        // }
        if (!formData.expiryDate) {
            newErrors.expiryDate = 'Expiry date is required';
        } else {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // clear time part for today
            const expiry = new Date(formData.expiryDate);

            if (expiry < today) {
                newErrors.expiryDate = 'Expiry date cannot be in the past';
            }
        }

        if (
            formData.startDate &&
            formData.expiryDate &&
            new Date(formData.startDate) > new Date(formData.expiryDate)
        ) {
            newErrors.expiryDate = 'Expiry date cannot be earlier than start date';
        }

        // Price
        if (!formData.price.trim()) {
            newErrors.price = 'Price is required';
        } else if (isNaN(Number(formData.price)) || Number(formData.price) <= 0) {
            newErrors.price = 'Please enter a valid positive number';
        }

        // Validity
        if (!formData.validity.trim()) {
            newErrors.validity = 'Price is required';
        } else if (isNaN(Number(formData.validity)) || Number(formData.validity) <= 0) {
            newErrors.validity = 'Please enter a valid days';
        }

        // Description
        if (!formData.description.trim()) {
            newErrors.description = 'Description is required';
        }
        // else if (formData.description.length < 10) {
        //     newErrors.description = 'Description must be at least 10 characters';
        // }

        // Numeric fields: Users, Domains, Page Views, Data Requests
        ['dataRequestLimit', 'pageViewsLimit', 'usersLimit', 'domainsLimit'].forEach(field => {
            if (formData[field] === '') {
                newErrors[field] = 'This field is required';
            } else if (isNaN(Number(formData[field])) || Number(formData[field]) < 0) {
                newErrors[field] = 'Please enter a valid number';
            }
        });

        // Overage Numbers Validation
        // ['dataRequestOverageNumber', 'pageViewsOverageNumber', 'usersOverageNumber', 'domainsOverageNumber'].forEach(field => {
        ['dataRequestOverageNumber', 'pageViewsOverageNumber'].forEach(field => {
            if (formData[field] === '') {
                newErrors[field] = 'This field is required';
            } else if (isNaN(Number(formData[field])) || Number(formData[field]) < 0) {
                newErrors[field] = 'Please enter a valid number';
            }
        });


        // Rich Text: Inclusion
        const html = formData.inclusion.trim();
        const stripped = html.replace(/<[^>]*>/g, '').trim(); // remove HTML tags

        if (!stripped) {
            newErrors.inclusion = 'Plan inclusion is required';
        }

        // if (formData.inclusion === '') {
        //     newErrors.inclusion = 'Plan inclusion is required';
        // }

        // Rich Text: Exclusion
        // if (formData.exclusion === '') {
        //     newErrors.exclusion = 'Plan exclusion is required';
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Enhanced change handler
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }

        setIsEdited(true)
    };

    // Enhanced checkbox change handler
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: checked
        }));
        setIsEdited(true)
    };

    // Rich text change handler
    const handleInputChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
        setIsEdited(true)
    };

    const handleSubmit = async () => {
        try {
            setIsSaving(true);

            // Perform validation
            if (!validate()) {
                setIsSaving(false);
                return;
            }

            const integrationData = integrationList
                .map(ele => formData[ele.name] ? ele.name : null)
                .filter(Boolean);

            // Prepare payload
            const payload = {
                plan_name: formData.planName,
                plan_description: formData.description,
                start_date: formData.startDate,
                end_date: formData.expiryDate,
                currency_id: formData.currency,
                price: formData.price,
                validity: formData.validity,
                plan_attributes: {
                    users: {
                        limit: formData.usersLimit,
                        is_soft_limit: formData.usersSoftLimit,
                        reset_frequency: "none",
                        overage: formData.usersOverageNumber
                    },
                    domains: {
                        limit: formData.domainsLimit,
                        is_soft_limit: formData.domainsSoftLimit,
                        reset_frequency: "none",
                        overage: formData.domainsOverageNumber
                    },
                    page_views: {
                        limit: formData.pageViewsLimit,
                        is_soft_limit: formData.pageViewsSoftLimit,
                        reset_frequency: "monthly",
                        overage: formData.pageViewsOverageNumber
                    },
                    data_requests: {
                        limit: formData.dataRequestLimit,
                        is_soft_limit: formData.dataRequestSoftLimit,
                        reset_frequency: "monthly",
                        overage: formData.dataRequestOverageNumber
                    },
                    data_breach: formData.dataBreach,
                    geo_location: formData.geoLocation,
                    privacy_policy_generator: formData.privacyPolicy,
                    integrations: [...integrationData]
                },
                plan_inclusion: removeEdgeQuotes(formData.inclusion) || '',
                plan_exclusion: removeEdgeQuotes(formData.exclusion) || ''
            };

            let response;

            if (section) {
                // Create license plan first
                const licenseResponse = await createLicense(payload);

                if (!licenseResponse?.success || !licenseResponse?.data?.plan_id) {
                    throw new Error(licenseResponse?.message || 'Failed to create license plan');
                }

                // Then create subscription with the new plan ID
                const subscriptionPayload = {
                    organization_id: id,
                    plan_id: licenseResponse.data.plan_id
                };

                response = await createSubscription(subscriptionPayload);

                if (!response?.success) {
                    throw new Error(response?.message || 'License created but subscription failed');
                }
                navigate('/customer/license');
                onClose()
                onCloseSubscription()
                showSuccessToast(`Subscription plan created successfully.`);
            } else {
                // Update or create license plan
                if (id) {
                    response = await updateLicense(id, payload);
                    if (response?.success) {
                        showSuccessToast(`License plan updated successfully.`);
                        navigate('/customer/license');
                    } else {
                        throw new Error(response?.message || 'Failed to update license plan');
                    }
                } else {
                    response = await createLicense(payload);
                    if (response?.success) {
                        showSuccessToast(`License plan created successfully.`);
                        navigate('/customer/license');
                    } else {
                        throw new Error(response?.message || 'Failed to create license plan');
                    }
                }
            }
        } catch (error) {
            console.error('Error in license/subscription operation:', error);
            showErrorToast(error.message || (section ?
                'Failed to create subscription plan. Please try again.' :
                'Failed to create license plan. Please try again.'));
        } finally {
            setIsSaving(false);
        }
    };

    if (loading) {
        return <Loader />
    }



    const breadcrumbItems = [
        {
            text: "License Plan",
            href: "/customer/license",
            onClick: () => navigate("/customer/license"),
        },
        {
            text: id ? "View" : "Create"
        },
    ];


    return (
        <Stack>
            {/* common back button */}
            <CustomBreadcrumb
                items={breadcrumbItems}
                onBackClick={() => {
                    navigate("/customer/license");
                }}
            />
            <Box>
                <Typography variant='h5' fontWeight='bold'>{section ? 'Create' : id ? 'View' : 'Create'} License Plan</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 4 }}>
                    {/* <Typography color='#989898' fontSize='14px'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</Typography> */}
                    <Typography color='#989898' fontSize='14px'>You can {section ? 'create' : id ? 'view and edit' : 'create'} the license on this page.</Typography>

                    <Button variant="outlined"
                        onClick={handleSubmit}
                        disabled={id && !isEdited}
                        sx={{
                            color: '#000',
                            borderWidth: 2,
                            borderColor: '#FF6348',
                            fontWeight: 600,
                            '&:hover': {
                                backgroundColor: '#FF6348',
                                color: '#fff'
                            }
                        }}
                    > {section ? (isSaving ? 'Saving...' : 'Save') :
                        (id ? (isSaving ? 'Updating...' : 'Update') : (isSaving ? 'Saving...' : 'Save'))}</Button>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                {/* Plan Base Details */}
                <Accordion
                    defaultExpanded
                    sx={{
                        bgcolor: '#F9FAFB',
                        width: '100%',
                        mb: 2, // consistent margin bottom between accordions
                        '& .MuiAccordionSummary-content': { margin: 0 },
                        '& .MuiAccordionDetails-root': { pt: 1 }, // reduce default top padding
                    }}
                >

                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '&.MuiAccordionSummary-root': {
                                minHeight: '50px',
                            },
                            '& .MuiAccordionSummary-content': {
                                margin: '4px 0',
                            },
                        }}>
                        <Typography variant="h6" sx={{ fontSize: '18px' }}>
                            Plan Base Details
                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'center', gap: 2 }}>
                                {/* Plan Name */}
                                <FormControl fullWidth error={Boolean(errors.planName)} sx={{ mb: 2 }}>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Plan Name
                                        <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                    </Typography>
                                    <TextField
                                        name="planName"
                                        value={formData.planName}
                                        onChange={handleChange}
                                        placeholder="Enter Your Plan Name"
                                        variant="outlined"
                                        size="small"
                                        sx={{ bgcolor: '#fff' }}
                                    />
                                    {errors.planName && <FormHelperText>{errors.planName}</FormHelperText>}
                                </FormControl>

                                {/* Start Date */}
                                <FormControl fullWidth error={Boolean(errors.startDate)} sx={{ mb: 2 }}>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Start Date
                                        <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                    </Typography>
                                    <TextField
                                        type='Date'
                                        name="startDate"
                                        value={formData.startDate}
                                        onChange={handleChange}
                                        placeholder="Enter Your Start Date"
                                        variant="outlined"
                                        size="small"
                                        sx={{ bgcolor: '#fff' }}
                                    />
                                    {errors.startDate && <FormHelperText>{errors.startDate}</FormHelperText>}
                                </FormControl>

                                {/* Expiry Date */}
                                <FormControl fullWidth error={Boolean(errors.expiryDate)} sx={{ mb: 2 }}>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Expiry Date
                                        <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                    </Typography>
                                    <TextField
                                        type='Date'
                                        name="expiryDate"
                                        value={formData.expiryDate}
                                        onChange={handleChange}
                                        placeholder="Enter Your Expiry Date"
                                        variant="outlined"
                                        size="small"
                                        sx={{ bgcolor: '#fff' }}
                                        InputProps={{
                                            inputProps: {
                                                min: new Date().toISOString().split('T')[0], // Disable past dates
                                            }
                                        }}
                                    />
                                    {errors.expiryDate && <FormHelperText>{errors.expiryDate}</FormHelperText>}
                                </FormControl>

                                {/* Price */}
                                <FormControl fullWidth error={Boolean(errors.price)} sx={{ mb: 2 }}>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Price
                                        <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            bgcolor: '#fff',
                                            py: .5, px: 1
                                        }}
                                    >
                                        <Select
                                            name="currency"
                                            value={formData.currency}
                                            onChange={handleChange}
                                            size="small"
                                            fullWidth
                                            displayEmpty
                                            variant="standard"
                                            disableUnderline
                                            disabled={section ? false : (id ? true : false)}
                                            sx={{
                                                // maxWidth: '70px',
                                                width: 'fit-content',
                                                bgcolor: 'transparent',
                                                border: 'none',
                                                '& fieldset': { border: 'none' },
                                                '& .MuiSelect-select': {
                                                    pb: 0, // Add padding-bottom: 0
                                                },
                                            }}
                                        >
                                            {currencyList && currencyList.length > 0 ? (
                                                currencyList.map((ele) => (
                                                    <MenuItem key={ele.currency_id} value={ele.currency_id}>
                                                        {ele.symbol} - {ele.code}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>No currencies available</MenuItem>
                                            )}
                                        </Select>

                                        <Divider
                                            orientation="vertical"
                                            flexItem
                                            sx={{ borderColor: '#ccc' }}
                                        />

                                        <TextField
                                            name="price"
                                            type="number"
                                            value={formData.price}
                                            onChange={handleChange}
                                            placeholder="Enter Price"
                                            variant="standard"
                                            size="small"
                                            fullWidth
                                            disabled={section ? false : (id ? true : false)}
                                            InputProps={{
                                                disableUnderline: true,
                                                inputProps: {
                                                    inputMode: 'numeric',   // Mobile: open numeric keyboard
                                                    pattern: '[0-9]*',       // Only numbers
                                                },
                                            }}
                                            sx={{
                                                bgcolor: 'transparent',
                                                border: 'none',
                                                '& fieldset': { border: 'none' },
                                                // REMOVE browser spinners
                                                '& input[type=number]': {
                                                    MozAppearance: 'textfield',
                                                },
                                                '& input[type=number]::-webkit-outer-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                },
                                                '& input[type=number]::-webkit-inner-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                },
                                            }}
                                        />

                                    </Box>
                                    {errors.price && <FormHelperText>{errors.price}</FormHelperText>}
                                </FormControl>

                                {/* Validity */}
                                <FormControl fullWidth error={Boolean(errors.validity)} sx={{ mb: 2 }}>
                                    <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                        Validity (Days)
                                        <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                    </Typography>
                                    <TextField
                                        name="validity"
                                        value={formData.validity}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) {
                                                handleChange(e); // Only allow digits
                                            }
                                        }}
                                        placeholder="Enter Validity Days"
                                        variant="outlined"
                                        size="small"
                                        sx={{ bgcolor: '#fff' }}
                                        disabled={section ? false : (id ? true : false)}
                                        InputProps={{
                                            disableUnderline: true,
                                            inputProps: {
                                                inputMode: 'numeric',   // Mobile: open numeric keyboard
                                                pattern: '[0-9]*',       // Only numbers
                                            },
                                        }}
                                    />
                                    {errors.validity && <FormHelperText>{errors.validity}</FormHelperText>}
                                </FormControl>
                            </Box>

                            {/* Description */}
                            <FormControl fullWidth error={Boolean(errors.description)}>
                                <Typography gutterBottom sx={{ color: "#5F5F5F" }}>
                                    Description
                                    <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                </Typography>
                                <TextField
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder="Enter Your Description"
                                    variant="outlined"
                                    size="small"
                                    multiline
                                    minRows={1}
                                    maxRows={3}
                                    sx={{
                                        bgcolor: '#fff',
                                    }}
                                />
                                {errors.description && <FormHelperText>{errors.description}</FormHelperText>}
                            </FormControl>
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {/* Plan Attributes */}
                <Accordion
                    sx={{
                        bgcolor: '#F9FAFB',
                        width: '100%',
                        mb: 2,
                        '& .MuiAccordionSummary-content': { margin: 0 },
                        '& .MuiAccordionDetails-root': { pt: 1 },
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '&.MuiAccordionSummary-root': {
                                minHeight: '50px',
                            },
                            '& .MuiAccordionSummary-content': {
                                margin: '4px 0',
                            },
                        }}>
                        <Typography variant="h6" sx={{ fontSize: '18px' }}>
                            Plan Attributes
                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box>
                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                {/* Data Request */}
                                <Grid item xs={12} sm={6} md={4} sx={fieldWrapperStyles}>
                                    <Stack sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Typography sx={{ width: '120px' }}>
                                            Data Request
                                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                        </Typography>
                                        <TextField
                                            name="dataRequestLimit"
                                            value={formData.dataRequestLimit}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    handleChange(e); // Only allow digits
                                                }
                                            }}
                                            placeholder="Enter limit"
                                            variant="outlined"
                                            size="small"
                                            sx={{ bgcolor: '#fff' }}
                                            error={Boolean(errors.dataRequestLimit)}
                                            helperText={errors.dataRequestLimit}
                                        />
                                    </Stack>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', }}>
                                        <Typography sx={{ width: '120px' }}>Soft Limits</Typography>
                                        <Checkbox
                                            checked={formData.dataRequestSoftLimit}
                                            onChange={(e) => setFormData({ ...formData, dataRequestSoftLimit: e.target.checked })}
                                            sx={{ p: 0 }}
                                            disabled
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Typography sx={{ width: '120px' }}>
                                            Overage
                                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                        </Typography>
                                        <Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    border: errors.dataRequestOverageNumber ? '1px solid red' : '1px solid #ccc', // 🔥 border turns red on error
                                                    borderRadius: '4px',
                                                    bgcolor: '#fff',
                                                    p: 1,
                                                }}
                                            >
                                                <Select
                                                    name="dataRequestOverageType"
                                                    value={formData.dataRequestOverageType}
                                                    onChange={handleChange}
                                                    size="small"
                                                    fullWidth
                                                    displayEmpty
                                                    variant="standard"
                                                    disableUnderline
                                                    sx={{
                                                        width: '110px',
                                                        bgcolor: 'transparent',
                                                        border: 'none',
                                                        '& fieldset': { border: 'none' },
                                                    }}
                                                >
                                                    <MenuItem value="absolute">Absolute</MenuItem>
                                                    <MenuItem value="percentage">Percentage</MenuItem>
                                                </Select>

                                                <Divider
                                                    orientation="vertical"
                                                    flexItem
                                                    sx={{ borderColor: '#ccc' }}
                                                />

                                                <TextField
                                                    name="dataRequestOverageNumber"
                                                    value={formData.dataRequestOverageNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            handleChange(e); // Only allow digits
                                                        }
                                                    }}
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                        inputProps: {
                                                            inputMode: 'numeric',   // Mobile: open numeric keyboard
                                                            pattern: '[0-9]*',       // Only numbers
                                                        },
                                                    }}
                                                    sx={{
                                                        width: '50px',
                                                        bgcolor: 'transparent',
                                                        border: 'none',
                                                        '& fieldset': { border: 'none' },
                                                    }}
                                                />
                                            </Box>

                                            {errors.dataRequestOverageNumber && (
                                                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
                                                    {errors.dataRequestOverageNumber}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>

                                {/* Page Views */}
                                <Grid item xs={12} sm={6} md={4} sx={fieldWrapperStyles}>
                                    <Stack sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Typography sx={{ width: '120px' }}>
                                            Page Views
                                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                        </Typography>
                                        <TextField
                                            name="pageViewsLimit"
                                            value={formData.pageViewsLimit}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    handleChange(e); // Only allow digits
                                                }
                                            }}
                                            placeholder="Enter limit"
                                            variant="outlined"
                                            size="small"
                                            sx={{ bgcolor: '#fff' }}
                                            error={Boolean(errors.pageViewsLimit)}
                                            helperText={errors.pageViewsLimit}
                                        />
                                    </Stack>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', }}>
                                        <Typography sx={{ width: '120px' }}>Soft Limits</Typography>
                                        <Checkbox
                                            checked={formData.pageViewsSoftLimit}
                                            onChange={(e) => setFormData({ ...formData, pageViewsSoftLimit: e.target.checked })}
                                            sx={{ p: 0 }}
                                            disabled
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Typography sx={{ width: '120px' }}>
                                            Overage
                                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                        </Typography>
                                        <Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    border: errors.pageViewsOverageNumber ? '1px solid red' : '1px solid #ccc', // 🔥 border turns red on error
                                                    borderRadius: '4px',
                                                    bgcolor: '#fff',
                                                    p: 1,
                                                }}
                                            >
                                                <Select
                                                    name="pageViewsOverageType"
                                                    value={formData.pageViewsOverageType}
                                                    onChange={handleChange}
                                                    size="small"
                                                    fullWidth
                                                    displayEmpty
                                                    variant="standard"
                                                    disableUnderline
                                                    sx={{
                                                        width: '110px',
                                                        bgcolor: 'transparent',
                                                        border: 'none',
                                                        '& fieldset': { border: 'none' },
                                                    }}
                                                >
                                                    <MenuItem value="absolute">Absolute</MenuItem>
                                                    <MenuItem value="percentage">Percentage</MenuItem>
                                                </Select>

                                                <Divider
                                                    orientation="vertical"
                                                    flexItem
                                                    sx={{ borderColor: '#ccc' }}
                                                />

                                                <TextField
                                                    name="pageViewsOverageNumber"
                                                    value={formData.pageViewsOverageNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            handleChange(e); // Only allow digits
                                                        }
                                                    }}
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                        inputProps: {
                                                            inputMode: 'numeric',   // Mobile: open numeric keyboard
                                                            pattern: '[0-9]*',       // Only numbers
                                                        },
                                                    }}
                                                    sx={{
                                                        width: '50px',
                                                        bgcolor: 'transparent',
                                                        border: 'none',
                                                        '& fieldset': { border: 'none' },
                                                    }}
                                                />
                                            </Box>

                                            {errors.pageViewsOverageNumber && (
                                                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
                                                    {errors.pageViewsOverageNumber}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>

                                {/* Users */}
                                <Grid item xs={12} sm={6} md={4} sx={fieldWrapperStyles}>
                                    <Stack sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Typography sx={{ width: '120px' }}>
                                            Users
                                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                        </Typography>
                                        <TextField
                                            name="usersLimit"
                                            value={formData.usersLimit}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    handleChange(e); // Only allow digits
                                                }
                                            }}
                                            placeholder="Enter limit"
                                            variant="outlined"
                                            size="small"
                                            sx={{ bgcolor: '#fff' }}
                                            error={Boolean(errors.usersLimit)}
                                            helperText={errors.usersLimit}
                                        />
                                    </Stack>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', }}>
                                        <Typography sx={{ width: '120px' }}>Soft Limits</Typography>
                                        <Checkbox
                                            checked={formData.usersSoftLimit}
                                            onChange={(e) => setFormData({ ...formData, usersSoftLimit: e.target.checked })}
                                            sx={{ p: 0 }}
                                        // disabled
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Typography sx={{ width: '120px' }}>Overage</Typography>
                                        <Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    border: errors.usersOverageNumber ? '1px solid red' : '1px solid #ccc', // 🔥 border turns red on error
                                                    borderRadius: '4px',
                                                    bgcolor: '#fff',
                                                    p: 1,
                                                }}
                                            >
                                                <Select
                                                    name="usersOverageType"
                                                    value={formData.usersOverageType}
                                                    onChange={handleChange}
                                                    size="small"
                                                    fullWidth
                                                    displayEmpty
                                                    variant="standard"
                                                    disableUnderline
                                                    sx={{
                                                        width: '110px',
                                                        bgcolor: 'transparent',
                                                        border: 'none',
                                                        '& fieldset': { border: 'none' },
                                                    }}
                                                >
                                                    <MenuItem value="absolute">Absolute</MenuItem>
                                                    <MenuItem value="percentage">Percentage</MenuItem>
                                                </Select>

                                                <Divider
                                                    orientation="vertical"
                                                    flexItem
                                                    sx={{ borderColor: '#ccc' }}
                                                />

                                                <TextField
                                                    name="usersOverageNumber"
                                                    value={formData.usersOverageNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            handleChange(e); // Only allow digits
                                                        }
                                                    }}
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                        inputProps: {
                                                            inputMode: 'numeric',   // Mobile: open numeric keyboard
                                                            pattern: '[0-9]*',       // Only numbers
                                                        },
                                                    }}
                                                    sx={{
                                                        width: '50px',
                                                        bgcolor: 'transparent',
                                                        border: 'none',
                                                        '& fieldset': { border: 'none' },
                                                    }}
                                                />
                                            </Box>

                                            {errors.usersOverageNumber && (
                                                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
                                                    {errors.usersOverageNumber}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>

                                {/* Domains */}
                                <Grid item xs={12} sm={6} md={4} sx={fieldWrapperStyles}>
                                    <Stack sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Typography sx={{ width: '120px' }}>
                                            Domains
                                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                                        </Typography>
                                        <TextField
                                            name="domainsLimit"
                                            value={formData.domainsLimit}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    handleChange(e); // Only allow digits
                                                }
                                            }}
                                            placeholder="Enter limit"
                                            variant="outlined"
                                            size="small"
                                            sx={{ bgcolor: '#fff' }}
                                            error={Boolean(errors.domainsLimit)}
                                            helperText={errors.domainsLimit}
                                        />
                                    </Stack>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', }}>
                                        <Typography sx={{ width: '120px' }}>Soft Limits</Typography>
                                        <Checkbox
                                            checked={formData.domainsSoftLimit}
                                            onChange={(e) => setFormData({ ...formData, domainsSoftLimit: e.target.checked })}
                                            sx={{ p: 0 }}
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Typography sx={{ width: '120px' }}>Overage</Typography>
                                        <Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    border: errors.domainsOverageNumber ? '1px solid red' : '1px solid #ccc', // 🔥 border turns red on error
                                                    borderRadius: '4px',
                                                    bgcolor: '#fff',
                                                    p: 1,
                                                }}
                                            >
                                                <Select
                                                    name="domainsOverageType"
                                                    value={formData.domainsOverageType}
                                                    onChange={handleChange}
                                                    size="small"
                                                    fullWidth
                                                    displayEmpty
                                                    variant="standard"
                                                    disableUnderline
                                                    sx={{
                                                        width: '110px',
                                                        bgcolor: 'transparent',
                                                        border: 'none',
                                                        '& fieldset': { border: 'none' },
                                                    }}
                                                >
                                                    <MenuItem value="absolute">Absolute</MenuItem>
                                                    <MenuItem value="percentage">Percentage</MenuItem>
                                                </Select>

                                                <Divider
                                                    orientation="vertical"
                                                    flexItem
                                                    sx={{ borderColor: '#ccc' }}
                                                />

                                                <TextField
                                                    name="domainsOverageNumber"
                                                    value={formData.domainsOverageNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            handleChange(e); // Only allow digits
                                                        }
                                                    }}
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                        inputProps: {
                                                            inputMode: 'numeric',   // Mobile: open numeric keyboard
                                                            pattern: '[0-9]*',       // Only numbers
                                                        },
                                                    }}
                                                    sx={{
                                                        width: '50px',
                                                        bgcolor: 'transparent',
                                                        border: 'none',
                                                        '& fieldset': { border: 'none' },
                                                    }}
                                                />
                                            </Box>

                                            {errors.domainsOverageNumber && (
                                                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
                                                    {errors.domainsOverageNumber}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                        <Stack direction="row" alignItems="center" marginTop={1} flexWrap="wrap" spacing={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="dataBreach"
                                        checked={formData.dataBreach}
                                        onChange={(e) =>
                                            // setFormData((prev) => ({ ...prev, dataBreach: e.target.checked }))
                                            handleChange(e)
                                        }
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                bgcolor: "#fff",
                                                borderRadius: "50%",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography variant="body2" color="#5F5F5F">Data Breach</Typography>}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="geoLocation"
                                        checked={formData.geoLocation}
                                        onChange={(e) =>
                                            // setFormData((prev) => ({ ...prev, geoLocation: e.target.checked }))
                                            handleChange(e)
                                        }
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                bgcolor: "#fff",
                                                borderRadius: "50%",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography variant="body2" color="#5F5F5F">Geo Location</Typography>}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="privacyPolicy"
                                        checked={formData.privacyPolicy}
                                        onChange={(e) =>
                                            // setFormData((prev) => ({ ...prev, privacyPolicy: e.target.checked }))
                                            handleChange(e)
                                        }
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                bgcolor: "#fff",
                                                borderRadius: "50%",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography variant="body2" color="#5F5F5F">Privacy Policy Generation</Typography>}
                            />
                        </Stack>

                    </AccordionDetails>
                </Accordion>

                {/* Integrations */}
                <Accordion
                    sx={{
                        bgcolor: '#F9FAFB',
                        width: '100%',
                        mb: 2,
                        '& .MuiAccordionSummary-content': { margin: 0 },
                        '& .MuiAccordionDetails-root': { pt: 1 },
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '&.MuiAccordionSummary-root': {
                                minHeight: '50px',
                            },
                            '& .MuiAccordionSummary-content': {
                                margin: '4px 0',
                            },
                        }}>
                        <Typography variant="h6" sx={{ fontSize: '18px' }}>
                            Integrations
                            {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack direction="row" alignItems="center" marginTop={1} flexWrap="wrap" spacing={2}>
                            {integrationList && integrationList.length > 0 && integrationList.map(ele => (
                                <FormControlLabel
                                    key={ele.integration_id}
                                    control={
                                        <Checkbox
                                            name={ele.name}
                                            checked={formData[ele.name]}
                                            onChange={handleCheckboxChange}
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    bgcolor: "#fff",
                                                    borderRadius: "50%",
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography variant="body2" color="#5F5F5F">{ele.name}</Typography>}
                                />))}

                            {/* <FormControlLabel
                                control={
                                    <Checkbox
                                        name="facebook"
                                        checked={formData.facebook}
                                        onChange={handleCheckboxChange}
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                bgcolor: "#fff",
                                                borderRadius: "50%",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography variant="body2" color="#5F5F5F">Facebook</Typography>}
                            /> 
                            
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="google"
                                        checked={formData.google}
                                        onChange={handleCheckboxChange}
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                bgcolor: "#fff",
                                                borderRadius: "50%",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography variant="body2" color="#5F5F5F">Google</Typography>}
                            /> 
                            
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="linkedIn"
                                        checked={formData.linkedIn}
                                        onChange={handleCheckboxChange}
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                bgcolor: "#fff",
                                                borderRadius: "50%",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography variant="body2" color="#5F5F5F">LinkedIn</Typography>}
                            /> */}
                        </Stack>

                    </AccordionDetails>
                </Accordion>

                {/* Plan Inclusion */}
                <Accordion
                    sx={{
                        bgcolor: '#F9FAFB',
                        width: '100%',
                        mb: 2,
                        '& .MuiAccordionSummary-content': { margin: 0 },
                        '& .MuiAccordionDetails-root': { pt: 1 },
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '&.MuiAccordionSummary-root': {
                                minHeight: '50px',
                            },
                            '& .MuiAccordionSummary-content': {
                                margin: '4px 0',
                            },
                        }}
                    >
                        <Typography variant="h6" sx={{ fontSize: '18px' }}>
                            Plan Inclusion
                            <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <RichTextComponent
                            name="inclusion"
                            value={formData.inclusion}
                            handleInputChange={handleInputChange}
                        />
                        {errors.inclusion && (
                            <Typography variant="caption" color="error">
                                {errors.inclusion}
                            </Typography>
                        )}
                    </AccordionDetails>
                </Accordion>


                {/* Plan Exclusion */}
                <Accordion
                    sx={{
                        bgcolor: '#F9FAFB',
                        width: '100%',
                        mb: 2,
                        '& .MuiAccordionSummary-content': { margin: 0 },
                        '& .MuiAccordionDetails-root': { pt: 1 },
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                            minHeight: '50px',
                            '&.MuiAccordionSummary-root': {
                                minHeight: '50px',
                            },
                            '& .MuiAccordionSummary-content': {
                                margin: '4px 0',
                            },
                        }}
                    >
                        <Typography variant="h6" sx={{ fontSize: '18px' }}>
                            Plan Exclusion
                            {/* <Box component="span" sx={{ color: "error.main", ml: 0.3 }}>*</Box> */}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <RichTextComponent
                            name="exclusion"
                            value={formData.exclusion}
                            handleInputChange={handleInputChange}
                        />
                        {errors.exclusion && (
                            <Typography variant="caption" color="error">
                                {errors.exclusion}
                            </Typography>
                        )}
                    </AccordionDetails>
                </Accordion>

            </Box>
        </Stack >
    )
}
